import api from './api';

export const createSurvey = async data => {
  try {
    const response = await api.post(`/surveys/add/`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getAll = async (is_active = 1) => {
  try {
    const response = await api.get(`/surveys/getAll/${is_active}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener las encuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getSurveyById = async id => {
  try {
    const response = await api.get(`/surveys/getSurveyById/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener la encuesta por ID:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para actualizar una encuesta
export const updateSurvey = async (id, data) => {
  try {
    const response = await api.put(`/surveys/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getWithAnswers = async (surveyId, surveyResponseId) => {
  try {
    const response = await api.get(
      `/surveys/getWithAnswers/${surveyId}/${surveyResponseId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener la encuesta con respuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const deleteSurvey = async id => {
  try {
    const response = await api.delete(`/surveys/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al eliminar la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getResponsesByDay = async surveyId => {
  try {
    const response = await api.get(`/reports/getResponsesByDay/${surveyId}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener las respuestas por día:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getTopResponseHours = async surveyId => {
  try {
    const response = await api.get(`/reports/getTopResponseHours/${surveyId}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el top de horarios:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
